import { Injectable } from '@angular/core';

export const LOCALSTORAGE_KEYS: any = {
    TOKEN: 'token',
    USER: 'user'
};

@Injectable()
export class LocalStorageService {
    constructor() { }

    get<T>(localStorageKey: string, c: { new(): T; }): T {
        if ((c as any).parseLocalStorage === undefined) {
            console.error('parseLocalStorage does not exist on type ' + c);
            return new c();
        } else {
            return (c as any).parseLocalStorage(JSON.parse(localStorage.getItem(localStorageKey)));
        }
    }

    getItem(localStorageKey: string): any {
        try {
            return JSON.parse(localStorage.getItem(localStorageKey));
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    set(localStorageKey: string, value: any): void {
        try {
            localStorage.setItem(localStorageKey, JSON.stringify(value));
        } catch (err) {
            console.error(err);
        }
    }

    clearStorage(): void {
        localStorage.removeItem(LOCALSTORAGE_KEYS.TOKEN);
        localStorage.removeItem(LOCALSTORAGE_KEYS.USER);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/local-storage/local-storage.service.ts